<template>
    <div class="bill-block" id="bill-block">
        <div class="info-title">我的账单</div>
        <!-- <div class="filter-layer">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="90px">
                <el-form-item label="查询条件" prop="condition">
                    <el-input v-model="queryParams.condition" placeholder="请输入查询条件" clearable size="small" />
                </el-form-item>
                <el-form-item label="联系人类型" prop="subject">
                    <el-select v-model="queryParams.subject" placeholder="请选择联系人类型" clearable size="small">
                        <el-option label="个人" value="person"></el-option>
                        <el-option label="企业" value="company"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="toQuery"
                        style="margin-left: 8px">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" size="small" @click="toExport">导出列表</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-row class="run-layer">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="toAdd">新增</el-button>
        </el-row> -->

        <div class="table-layer" style="padding: 0 20px 20px;">
            <el-table ref="listTableRef" :data="billList"
                :header-cell-style="{ background: '#F2F3F5', color: '#1D2129', fontWeight: 500, padding: '12px 10px' }"
                :cell-style="{
                    color: '#313843',
                    fontWeight: 400,
                    padding: '12px 10px'
                }" height="100%">

                <el-empty description="暂无数据" slot="empty" :image="require('@/assets/images/home/default.png')"
                    :image-size="220">
                </el-empty>
                <!-- <el-table-column type="index" label="序列号" width="80"></el-table-column> -->
                <el-table-column prop="orderNumber" label="订单号" width="190" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unitPrice" label="单价（元）" width="100"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
                <el-table-column prop="amount" label="总额（元）" width="100"></el-table-column>
                <el-table-column prop="status" label="支付状态" width="100">
                    <template slot-scope="scope" width="100">
                        <div class="scope-content">
                            <div class="flex-center" v-if="scope.row.status == 'notPay'">
                                <span class="dot" style=" background: #EA8B56"></span>
                                <span>待支付</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'pay'">
                                <span class="dot" style=" background: #00B42A"></span>
                                <span>支付成功</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'failPay'">
                                <span class="dot" style=" background: #EC5B56"></span>
                                <span>审核失败</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'passPay'">
                                <span class="dot" style=" background: #00D4CD"></span>
                                <span>审核通过</span>
                            </div>
                            <div class="flex-center" v-if="scope.row.status == 'processing'">
                                <span class="dot" style=" background: #CCCCCC"></span>
                                <span>审核中</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="payType" label="支付方式" width="100">
                    <template slot-scope="scope">
                        <div class="scope-content">
                            <span v-if="scope.row.payType == 'zfb'">支付宝</span>
                            <span v-else-if="scope.row.payType == 'wx'">微信</span>
                            <span v-else-if="scope.row.payType == 'yl'">银联</span>
                            <span v-else-if="scope.row.payType == 'hzd'">电汇</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="usedNumber" label="使用数量" width="100"/>
                <el-table-column prop="surplus" label="剩余数量" width="100"/>
                <el-table-column prop="expirationTime" label="过期时间" width="190">
                    <template slot-scope="scope">
                        <div class="scope-content">
                            <span v-if="scope.row.expirationTime">{{ scope.row.expirationTime }}</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="190">
                    <template slot-scope="scope">
                        <div class="scope-content">
                            <span v-if="scope.row.createTime">{{ scope.row.createTime }}</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.remark">
                            <span class="remark-text">{{ scope.row.remark }}</span>
                        </div>
                        <div v-else>
                            <span class="remark-text">无</span>
                        </div>
                    </template>

                </el-table-column>
                <el-table-column label="操作" fixed="right" width="90">
                    <template slot-scope="scope">
                        <el-button type="text" @click="toPay(scope.row)" v-if="scope.row.status == 'notPay'">去支付
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <transition name="el-zoom-in-bottom">
                <span class="top-btn" v-show="topBtnShow" @click="handleListTable2Top"></span>
            </transition>
        </div>

        <div class="pager-layer">
            <el-pagination v-if="billList && billList.length" :total="total" :current-page.sync="queryParams.pageNum"
                layout="sizes, total, prev, pager, next" :page-sizes="[5, 10, 20, 100]"
                :page-size.sync="queryParams.pageSize" @size-change="sizeChange" @current-change="pageChange" />
        </div>


        <el-dialog title="新增外部联系人" :visible.sync="addContactOpen" width="500px" append-to-body
            :close-on-click-modal="false">
            <el-form ref="addForm" :model="addForm" :rules="
                addForm.subject === 'company' ? addFormRulesCompany : addFormRules
            " label-width="120px">
                <el-form-item label="联系人类型">
                    <el-radio-group v-model="addForm.subject" @change="handleChangeSubject">
                        <el-radio label="person">个人</el-radio>
                        <el-radio label="company">企业</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="企业名称" prop="companyName" required v-if="addForm.subject === 'company'">
                    <el-input v-model="addForm.companyName" placeholder="请输入企业名称" maxlength="30" />
                </el-form-item>
                <el-form-item :label="addForm.subject === 'company' ? '经办人姓名' : '经办人姓名'" prop="personName">
                    <el-input v-model="addForm.personName" :placeholder="
                        addForm.subject === 'company'
                            ? '请输入经办人姓名'
                            : '请输入经办人姓名'
                    " maxlength="30" />
                </el-form-item>
                <el-form-item :label="
                    addForm.subject === 'company' ? '经办人手机号' : '经办人手机号'
                " prop="personAddress">
                    <el-input v-model="addForm.personAddress" :placeholder="
                        addForm.subject === 'company'
                            ? '请输入经办人手机号'
                            : '请输入经办人手机号'
                    " maxlength="11" />
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="addForm.remark" type="textarea" placeholder="请输入内容" maxlength="30"
                        show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" @click="addContactSubmitForm">确 定</el-button>
                <el-button @click="cancelAddContact">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getBillList, addContact, removeContact } from "@/api/bill";
import { getToken } from "@/utils/auth";
import { parseTime, downloadFile } from "@/utils/index";
import { mapState } from "vuex";
export default {
    data() {
        return {
            loaded: false,
            billList: [],
            dialogVisible: false,
            sealId: "",
            lastFlag: "",
            queryParams: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            // page: 1,
            addContactOpen: false,
            addForm: {
                subject: "person",
                companyName: "",
                personName: "",
                personAddress: "",
                remark: "",
            },
            addFormRules: {
                subject: [
                    {
                        required: true,
                        message: "请选择联系人类型",
                        trigger: ["blur", "change"],
                    },
                ],
                companyName: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: ["blur", "change"],
                    },
                ],
                personName: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: ["blur", "change"],
                    },
                ],
                personAddress: [
                    {
                        required: true,
                        message: "请输入经办人手机号",
                        trigger: ["blur", "change"],
                    },
                ],
            },
            addFormRulesCompany: {
                subject: [
                    {
                        required: true,
                        message: "请选择联系人类型",
                        trigger: ["blur", "change"],
                    },
                ],
                companyName: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: ["blur", "change"],
                    },
                ],
            },
            submitLoading: false,
            topBtnShow: false
        };
    },
    computed: mapState(["companyList", "currentSpace", "userInfo"]),
    created() {
        this.getBillList();
    },
    mounted() {
        window
            .addEventListener("scroll", (e) => {
                if (this.$refs.listTableRef) {
                    let target = this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper");
                    e.preventDefault();
                    // e.stopPropagation();
                    if (target.scrollTop > 100) {
                        this.topBtnShow = true;
                    } else {
                        this.topBtnShow = false;
                    }
                }
            }, true)
    },
    methods: {
        handleChangeSubject() {
            this.$nextTick(() => {
                this.$refs.addForm.resetFields();
            });
        },
        getBillList() {
            getBillList(this.queryParams)
                .then((res) => {
                    this.loaded = true;
                    if (res.code != 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.loaded = false;
                        this.billList = res.rows;
                        this.total = res.total;

                        document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.billList.length + 1) + 'px';
                        document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
                        document.querySelector(".table-layer").style.height = document.getElementById("bill-block").offsetHeight - 60 - 60 + "px";
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleListTable2Top() {
            this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper").scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        },
        sizeChange() {
            this.toQuery();
        },
        pageChange() {
            this.toQuery();
        },
        toQuery() {
            this.getBillList();
        },
        toAdd() {
            this.addForm = {
                subject: "person",
                companyName: "",
                personName: "",
                personAddress: "",
                remark: "",
            };
            this.addContactOpen = true;
            this.$nextTick(() => {
                this.$refs.addForm.resetFields();
            });
        },
        submitForm() { },
        getUserInfoHandle() {
            contractCountApi()
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.$store.commit("SET_USER_CONTRSCT_INFO", res.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        beforeInit() {
            // console.log(this.queryParams.dateRange);
            this.url = "/api/common/v1/task/list";
            var startSignTime = this.queryParams.dateRange
                ? this.queryParams.dateRange[0]
                : "";
            var endSignTime = this.queryParams.dateRange
                ? this.queryParams.dateRange[1]
                : "";
            if (this.lastFlag != this.$route.query.state) {
                this.page = 1;
                this.size = 5;
            }
            this.lastFlag = this.$route.query.state;
            this.params = {
                pageNum: this.page,
                pageSize: this.size,
                companyId: this.currentSpace.companyId || "",
                status: this.$route.query.state,
                taskName: this.queryParams.taskName,
                startSignTime: startSignTime,
                endSignTime: endSignTime,
                initiatorName: this.queryParams.initiatorName,
                signerName: this.queryParams.signerName,
            };
            return true;
        },

        toContractInfo(signId) {
            this.$router.push({
                path: "/temp-info",
                query: {
                    signId,
                },
            });
        },
        updateTaskStatus2Send(info) {
            this.$confirm("确定要发送吗？", "温馨提示", {
                confirmButtonText: "发送",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateTaskStatus2Send({ signId: info.signId })
                        .then((res) => {
                            console.log(res);
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "发送成功！",
                                    type: "success",
                                });
                                this.init();
                                this.getUserInfoHandle();
                                this.$parent.handleGetSpaceDetailInfo();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },
        toPay(row) {
            this.$router.push({
                path: "/cart/order",
                query: {
                    orderId: row.id
                },
            });
        },

        // sendContract(info) {
        // 	this.$router.push({
        // 		path: "/flow",
        // 		query: {
        // 			contractId: info.contractId
        // 		}
        // 	});
        // },
        pendTrialHandle(contractId) {
            sendApproveApi({
                contractId: contractId,
                nocache: new Date().getTime(),
            })
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: "送审成功！",
                            type: "success",
                        });

                        this.init();
                        this.getUserInfoHandle();
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        toEdit(info) {
            this.$router.push({
                path: "/temp-create",
                query: {
                    taskId: info.taskId,
                },
            });
            // if (info.status == 1) {
            //   var names = info.names.split(',');
            //   var isFirst = 'true'
            //   if (names[0] == this.userInfo.name) {
            //     isFirst = 'true'
            //   } else {
            //     isFirst = 'false'
            //   }

            //   this.$router.push({
            //     path: '/set-control',
            //     query: {
            //       contractId: info.contractId,
            //       isFirst: isFirst,
            //       isSame: true
            //     }
            //   })
            // } else if (info.status == 0) {
            //   this.$router.push({
            //     path: '/flow',
            //     query: {
            //       contractId: info.contractId
            //     }
            //   })
            // }
        },
        toDownload(info) {
            downloadContractApi({
                signId: info.signId,
            })
                .then((res) => {
                    downloadFile(res, info.taskName, "zip");
                })
                .catch((err) => {
                    console.log(err);
                });
            // window.location.href = process.env.VUE_APP_BASE_API+'/contract/download?contractId='+contractId
        },
        // toExport() {
        // 	var startSignTime = this.queryParams.dateRange
        // 		? this.queryParams.dateRange[0]
        // 		: "";
        // 	var endSignTime = this.queryParams.dateRange
        // 		? this.queryParams.dateRange[1]
        // 		: "";
        // 	var params = {
        // 		pageIndex: this.page,
        // 		pageSize: this.size,
        // 		companyId: this.currentSpace.companyId || "",
        // 		flag: this.$route.query.state,
        // 		taskName: this.queryParams.taskName,
        // 		startSignTime: startSignTime,
        // 		endSignTime: endSignTime,
        // 		initiatorName: this.queryParams.initiatorName,
        // 		signerName: this.queryParams.signerName
        // 	};
        // 	downloadContracExcelApi(params)
        // 		.then(res => {
        // 			downloadFile(res, "合同列表", "xlsx");
        // 		})
        // 		.catch(err => {
        // 			console.log(err);
        // 		});
        // },
        // toDownloadEvidence(info) {
        // 	downloadContractEvidenceApi(info.contractId)
        // 		.then(res => {
        // 			downloadFile(res, info.taskName + "_签署报告", "pdf");
        // 		})
        // 		.catch(err => {
        // 			console.log(err);
        // 		});
        // 	// window.location.href = process.env.VUE_APP_BASE_API+'/contract/download?contractId='+contractId
        // },

        rejectContractHandle(signId) {
            this.$confirm("确定要拒签该合同吗？", "温馨提示", {
                confirmButtonText: "拒签",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateTaskStatus2Reject({
                        signId: signId,
                    })
                        .then((res) => {
                            console.log(res);
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "拒签成功！",
                                    type: "success",
                                });

                                this.init();
                                this.getUserInfoHandle();
                                // setTimeout(() => {
                                // 	location.reload();
                                // }, 200);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },

        withdraw(contractId) {
            this.$confirm("确定要撤回该合同吗？", "温馨提示", {
                confirmButtonText: "撤回",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    recallContractApi({
                        contractId: contractId,
                    })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "撤回成功！",
                                    type: "success",
                                });

                                this.init();
                                this.getUserInfoHandle();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },
        recallApproveHandle(contractId) {
            this.$confirm("确定要撤回该审批吗？", "温馨提示", {
                confirmButtonText: "撤回",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    recallApproveApi({
                        contractId: contractId,
                        nocache: new Date().getTime(),
                    })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "撤回成功！",
                                    type: "success",
                                });

                                this.init();
                                this.getUserInfoHandle();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },
        toSign(info) {
            // if (this.userInfo.name != info.signUserName) {
            //   this.$message({
            //     showClose: true,
            //     message: '当前签署人与指定签署人不一致！',
            //     type: 'warning'
            //   });

            //   return;
            // }

            this.$router.push({
                path: "/signing",
                query: {
                    signId: info.signId,
                    signType: this.currentSpace.companyId ? "1" : "0",
                    companyId: this.currentSpace.companyId,
                },
            });
        },
        // showContractImgList(info) {
        // 	getSignFileImgArray({
        // 		signFileId: info.signId
        // 	})
        // 		.then(res => {
        // 			console.log(res);
        // 			if (res.code !== 200) {
        // 				this.$message({
        // 					showClose: true,
        // 					message: res.message,
        // 					type: "warning"
        // 				});
        // 			} else {
        // 				this.pngList = res.data.pngList.map(el => {
        // 					console.log(el);
        // 					console.log(getToken());
        // 					return (
        // 						process.env.VUE_APP_BASE_API +
        // 						el +
        // 						getToken() +
        // 						"&r=" +
        // 						new Date().getTime()
        // 					);
        // 				});

        // 				this.dialogVisible = true;
        // 			}
        // 		})
        // 		.catch(err => {
        // 			console.log(err);
        // 		});
        // }
        addContactSubmitForm() {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    addContact(this.addForm)
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.getbillList();
                                this.addContactOpen = false;
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            });
        },
        cancelAddContact() {
            this.addContactOpen = false;
        },
        toDelete(info) {
            this.$confirm("确定要删除吗？", "温馨提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    removeContact({ contactId: info.id })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.getbillList();
                                this.$message({
                                    showClose: true,
                                    message: "删除成功！",
                                    type: "success",
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },
    },
};
</script>
<style scoped>
.text-btn {
    color: #666666 !important;
}

.text-btn:hover {
    color: #4489ee !important;
}

.filter-layer .el-form .el-form-item {
    margin-bottom: 0;
}
</style>
<style lang="scss" scoped>
.el-submenu.is-active .el-submenu__title {
    border-left: 3px solid #3296fa;
}

.scope-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.filter-layer {
    // height: 100px;
    padding-left: 22px;
    padding-top: 30px;
    // margin-bottom: 20px;
}

.run-layer {
    padding-left: 42px;
    padding-top: 30px;
    margin-bottom: 20px;
}

.remark-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<style lang="scss" scoped>
.bill-block {
    position: relative;
    height: 100%;
}

.info-title {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    font-weight: 500;
    color: #1D2129;
    border-bottom: 1px solid #F2F3F5;
    padding-left: 22px;
}

.el-table {
    min-height: 360px;
}

.filter-layer {
    padding: 16px 0 16px 20px;

    .el-button /deep/ span {
        display: flex;
        align-items: center;

        .svg-icon {
            margin-right: 7px;
        }
    }
}

.pager-layer {
    width: 100%;
    height: 60px;
    padding-right: 20px;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: #fff;
    z-index: 99;
}

.el-form-item {
    margin-right: 24px;
    margin-bottom: 16px;
    height: 32px;
    line-height: 32px;

    /deep/ .el-form-item__label {
        font-size: 14px;
        font-weight: 400;
        color: #4E5969;
    }

    // &+.el-form-item {
    //     // margin-left: 24px;


    // }

    .el-button {
        min-width: 84px;
    }
}

.el-input {
    height: 32px;
    line-height: 32px;

    /deep/ .el-input__inner {
        width: 240px;
    }
}

.el-select {
    /deep/ .el-input__inner {
        // width: 240px;
        width: 212px;
    }
}

.table-layer {
    margin-top: 20px;
    height: auto;
    padding-right: 20px;

    .top-btn {
        display: block;
        width: 60px;
        height: 60px;
        background: url(../../assets/icons/png/icon-top.png) center no-repeat;
        background-size: 100%;
        // box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
        // border: 1px solid rgba(220, 220, 220, 0.5);
        position: absolute;
        right: 40px;
        bottom: 68px;
        z-index: 999;
        color: #93A4BC;
        padding: 0;
        cursor: pointer;
    }

    .dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        margin-right: 8px;
    }

    /deep/ .selection-column .cell {
        padding-left: 12px !important;
    }

}

.el-table {
    width: 100%;

    /deep/ .el-table__row td:nth-last-of-type(1) .cell,
    /deep/ thead th:nth-last-of-type(1) .cell {
        padding-left: 14px !important;
    }

    // /deep/ .cell {
    //     padding-left: 14px !important;
    //     padding-right: 10px !important;
    //     // padding: 0 !important;
    // }

    /deep/ .el-table__cell {
        height: 46px;
        padding: 0 !important;
    }

    /deep/ .el-table__fixed,
    /deep/ .el-table__fixed-right {
        // box-shadow: -2px 0px 2px 0px rgba(0, 0, 0, 0.1);
        box-shadow: none;
        height: 0;
    }

    /deep/ .el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right {
        box-shadow: none;
    }

    .el-button--text {
        font-size: 14px;
        font-weight: 400;
        color: #165DFF;
        padding: 0;

        &.grey {
            color: #86909C;
        }

        &:hover {
            opacity: .7;
        }

        &.danger {
            color: #EC5B56;
        }

    }

    .el-button+.el-button {
        margin-left: 11px;
    }
}
</style>